var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsTopup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3F7CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 13.3333H16.6667C16.4899 13.3333 16.3203 13.4036 16.1953 13.5286C16.0703 13.6536 16 13.8232 16 14V18C16 18.1768 16.0703 18.3464 16.1953 18.4714C16.3203 18.5964 16.4899 18.6667 16.6667 18.6667H22.6667V21.3333C22.6667 21.5101 22.5965 21.6797 22.4714 21.8047C22.3464 21.9298 22.1769 22 22 22H10C9.82323 22 9.65366 21.9298 9.52864 21.8047C9.40361 21.6797 9.33337 21.5101 9.33337 21.3333V10.6667C9.33337 10.4899 9.40361 10.3203 9.52864 10.1953C9.65366 10.0702 9.82323 10 10 10H22C22.1769 10 22.3464 10.0702 22.4714 10.1953C22.5965 10.3203 22.6667 10.4899 22.6667 10.6667V13.3333ZM18 15.3333H20V16.6667H18V15.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsTopup);
export default __webpack_public_path__ + "static/media/actions-topup.0fd52f48203c5f46c74fb4895a44f3c9.svg";
export { ForwardRef as ReactComponent };